import * as React from 'react'

import { ExperimentsContext, ExperimentsContextData } from '../../context'
export interface Props {
  children: React.ReactNode
}

// Original is a special variant who's variant id is always 0 and represents the original variant
// By default this will render while the experiment is loading, then the selected variant will replace it
const Original: React.SFC<Props> = ({ children }) => (
  <ExperimentsContext.Consumer>
    {({ selectedVariantId }: ExperimentsContextData) =>
      selectedVariantId === undefined || selectedVariantId === '0' ? children : null
    }
  </ExperimentsContext.Consumer>
)

export default Original
